import React from "react";
import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { formatDate } from "../../utils/dateUtils";
import { DocumentFile } from "../../models/Document";

interface PdfDocumentsModalProps {
    show: boolean;
    onClose: () => void;
    pdfDocuments: DocumentFile[];
}

const PdfDocumentsModal: React.FC<PdfDocumentsModalProps> = ({ show, onClose, pdfDocuments }) => {
    const { t } = useTranslation(["documents", "common"]);

    return (
        <>
            <Modal show={show} onHide={onClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{t("modal.title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfDocuments && (
                        <div className="table-responsive">
                            <table className="table table-striped table-align-middle">
                                <thead>
                                    <tr>
                                        <th scope="col">{t("common:headers.name")}</th>
                                        <th scope="col">{t("common:headers.updatedAt")}</th>
                                        <th scope="col" className="text-nowrap">
                                            {t("common:headers.actions")}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pdfDocuments.map((document) => (
                                        <tr key={document.id}>
                                            <td>{document.name || document.id}</td>
                                            <td>{formatDate(document.updatedAt)}</td>
                                            <td className="text-nowrap shrink">
                                                <button
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={() => window.open(document.url, "_blank")}
                                                    title={t("modal.openPdfTitle")}
                                                >
                                                    <FileText size={16} />
                                                    {t("table.actions.openPdf")}
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>
                        {t("common:buttons.close")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PdfDocumentsModal;
